import { all, AllEffect, call, ForkEffect, put, StrictEffect, takeEvery } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';
import { BffResponse, BffWalletResponse } from '@lucky7ventures/bff-types';
import BffApiService from '@/shared/bffApiService';
import {
  getUserWalletError,
  getUserWalletSuccess,
  UserWalletActionType,
} from '@/store/wallet/actions';
import { bffApiErrorHandler } from '@/shared/errorHandler';

export function* getUserWalletSaga(): Generator<
  StrictEffect,
  void,
  AxiosResponse<BffResponse<BffWalletResponse>>
> {
  try {
    const response = yield call(BffApiService.getWallet);

    if (response.data.data) {
      yield put(getUserWalletSuccess(response.data.data));
    }
  } catch (error) {
    const bffError = bffApiErrorHandler(error as AxiosError);
    yield put(getUserWalletError(bffError.code));
  }
}

export function* watchUserWalletSagas(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeEvery(UserWalletActionType.GetUserWallet, getUserWalletSaga)]);
}
